import type { PropsWithChildren } from 'react'
import { useParams } from 'react-router-dom'
import { isLocale } from '@utils'
import { EntryPoint } from './lazyComponents'

/** Renders children only when :locale is in the Crowdin-backed allowlist. */
export function LocalePathGate({ children }: PropsWithChildren) {
  const { locale } = useParams()

  if (!isLocale(locale)) {
    return <EntryPoint />
  }

  return <>{children}</>
}
